import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import DefaultTemplate from '../templates/default';

const IndexPage = ({ location, data }) => {
  return (
    <DefaultTemplate
      pageContext={{ data: data.prodigy.pages[0] }}
      location={location}
    />
  );
};

IndexPage.propTypes = {
  location: PropTypes.shape().isRequired,
  data: PropTypes.shape().isRequired,
};

export const query = graphql`
  query MyHomeEnglishQuery {
    prodigy {
      pages(pageName: "home", locale: "en-ca") {
        id
        lang
        localePath
        title {
          text
          type
          spans {
            start
            end
          }
        }
        metaData {
          metaDescription
          metaKeywords
          metaNoIndex
        }
        theme {
          colors {
            primary
            secondary
            accent
            neutral_1
            neutral_2
            neutral_3
            text_Accent
            text_Primary
            text_Secondary
          }
          fonts {
            primary
            secondary
          }
        }
        blogSearchBar {
          title {
            text
            type
            spans {
              start
              end
            }
          }
          subTitle {
            text
            type
            spans {
              start
              end
            }
          }
          searchText
          searchPlaceHolderText
          filterText
          searchIcon {
            altTag
            url
          }
          socialShare {
            icon {
              url
              altTag
            }
            imageIcon {
              url
              altTag
            }
            imageIconSharp {
              publicURL
            }
            queryString
            ariaLabel
            link {
              url
            }
            type {
              text
              type
              spans {
                start
                end
              }
            }
          }
        }
        slices {
          primary {
            ... on prodigyapi_awardPrimary {
              type
              title {
                type
                text
                spans {
                  start
                  end
                }
              }
              colourOverrideBackground
              width
              titleHtml
            }
            ... on prodigyapi_heroSlice {
              type
              component
              bannerCTAText
              ctaType
              gridImageAlignment
              subheading {
                text
                type
                spans {
                  start
                  end
                }
              }
              heading {
                text
                type
                spans {
                  start
                  end
                }
              }
              bannerCTA {
                url
                linkType
              }
              backgroundImage {
                url
                altTag
              }
              imageBackground {
                url
                altTag
              }
              imageBackgroundSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              foregroundImage {
                url
                altTag
              }
              circleAlignment
              textWidthBool
              formId
              headingHtml
              subheadingHtml
              imageMobileBG {
                url
                altTag
              }
              imageMobileBGSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              imageForeground {
                url
                altTag
              }
              imageForegroundSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              ariaLabel
              queryString
              bannerCTATextSecondary
              bannerCTASecondary {
                url
                linkType
              }
              ctaTypeSecondary
              ariaLabelSecondary
            }
            ... on prodigyapi_heroBanner {
              type
              component
              bannerCTAText
              ctaType
              subheading {
                text
                type
                spans {
                  start
                  end
                }
              }
              heading {
                text
                type
                spans {
                  start
                  end
                }
              }
              bannerCTA {
                url
                linkType
              }
              mobileHeroImage {
                url
                altTag
              }
              headingHtml
              subheadingHtml
              heroImage {
                url
                altTag
              }
              ariaLabel
              queryString
            }
            ... on prodigyapi_videoWithListPrimary {
              type
              icon
              image {
                url
                altTag
              }
              title {
                text
                type
                spans {
                  end
                  start
                }
              }
              subheading {
                text
                type
                spans {
                  start
                  end
                }
              }
              video {
                width
                version
                type
                title
                thumbnailURL
                thumbnailWidth
                thumbnailHeight
                providerURL
                providerName
                html
                height
                embedURL
                cacheAge
                authorURL
                authorName
              }
              component
              colourOverrideText
              colourOverrideBackground
              ctaLink {
                url
              }
              ctaLocation
              ctaText
              ctaType
              mediaPosition
              mediaType
              subheadingLocation
              mediaFixedPosition
              subheadingOverList {
                text
                type
                spans {
                  start
                  end
                }
              }
              imageSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              subheadingHtml
              subheadingOverListHtml
              titleHtml
              ariaLabel
              queryString
            }
            ... on prodigyapi_testimonialPrimary {
              type
              title {
                text
                type
                spans {
                  start
                  end
                }
              }
              colourOverrideBackground
              colourOverrideCardBG
              colourOverrideText
              titleHtml
            }
            ... on prodigyapi_columnImagesOverTextPrimary {
              type
              sectionTitle {
                type
                text
                spans {
                  end
                  start
                }
              }
              component
              image {
                url
                altTag
              }
              title {
                type
                text
                spans {
                  end
                  start
                }
              }
              buttonText
              buttonLink {
                url
              }
              focusTextColour
              columnCount
              columnAlignment
              colourOverrideText
              colourOverrideBackground
              buttonType
              imageSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              sectionTitleHtml
              titleHtml
              ariaLabelButton
              queryStringButton
            }
            ... on prodigyapi_richTextSlice {
              type
              anchorSlug
              richText {
                type
                text
                spans {
                  start
                  end
                  data_type
                  data {
                    fontName
                  }
                }
              }
              richTextHtml
            }
            ... on prodigyapi_fullWidthImageAndTextBoxesPrimary {
              type
              image {
                url
                altTag
              }
              title {
                text
                spans {
                  start
                  end
                }
              }
              columnCount
              titleHtml
              imageSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              colourOverrideBackground
              colourOverrideCardBG
            }
            ... on prodigyapi_imageWithTextPrimary {
              type
              imageWidth
              image {
                url
                altTag
              }
              imagePosition
              photoCredit
              text {
                text
                spans {
                  start
                  end
                }
                type
              }
              sectionTitle {
                text
              }
              sectionTitleHtml
              textHtml
              textWidth
              imageSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
            ... on prodigyapi_dualColourTextPrimary {
              type
              ctaLabelSection_1
              textSection_2 {
                text
                type
                spans {
                  start
                  end
                }
              }
              textSection_1 {
                text
                type
                spans {
                  start
                  end
                }
              }
              headingSection_2 {
                text
                spans {
                  start
                  end
                }
                type
              }
              headingSection_1 {
                text
                type
                spans {
                  start
                  end
                }
              }
              ctaSection_2 {
                url
              }
              ctaSection_1 {
                url
              }
              ctaLabelSection_2
              imageLeft {
                url
                altTag
              }
              imageRight {
                url
                altTag
              }
              imageLeftSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              imageRightSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              subHeading {
                text
                spans {
                  end
                  start
                }
              }
              title {
                text
                spans {
                  end
                  start
                }
              }
              ctaType
              ctaType_2
              headingSection_1Html
              headingSection_2Html
              subHeadingHtml
              textSection_1Html
              textSection_2Html
              titleHtml
              colourOverrideBackground_1
              colourOverrideBackground_2
              colourOverrideCardText_1
              colourOverrideCardText_2
              queryString_2
              queryString_1
              ariaLabel_1
              ariaLabel_2
            }
            ... on prodigyapi_videoSlice {
              type
              video {
                width
                version
                type
                title
                thumbnailURL
                thumbnailWidth
                thumbnailHeight
                providerURL
                providerName
                html
                height
                embedURL
                cacheAge
                authorURL
                authorName
              }
              title {
                text
                type
                spans {
                  end
                  start
                }
              }
              subtitle {
                type
                text
                spans {
                  start
                  end
                }
              }
              image {
                url
                altTag
              }
              subtitleHtml
              titleHtml
            }
            ... on prodigyapi_videoSliceWithCTA {
              type
              video {
                width
                version
                type
                title
                thumbnailURL
                thumbnailWidth
                thumbnailHeight
                providerURL
                providerName
                html
                height
                embedURL
                cacheAge
                authorURL
                authorName
              }
              title {
                text
                type
                spans {
                  end
                  start
                }
              }
              subtitle {
                type
                text
                spans {
                  start
                  end
                }
              }
              image {
                url
                altTag
              }
              subtitleHtml
              titleHtml
              bannerCTA {
                url
                linkType
              }
              bannerCTAText
              ctaType
              ariaLabel
              queryString
            }
            ... on prodigyapi_imageBesideTextPrimary {
              type
              title {
                type
                text
                spans {
                  data {
                    fontName
                    id
                    isBroken
                    lang
                    linkType
                    slug
                    tags
                    target
                    type
                    uid
                    url
                  }
                  data_type
                  end
                  start
                }
              }
              ctaType
              ctaText
              component
              ctaLink {
                url
              }
              subheading {
                type
                text
                spans {
                  start
                  end
                  data {
                    fontName
                    id
                    isBroken
                    lang
                    linkType
                    slug
                    target
                    url
                    uid
                    type
                    tags
                  }
                  data_type
                }
              }
              subheadingHtml
              titleHtml
              colourOverrideBackground
              ariaLabel
              queryString
              colourOverrideText
            }
            ... on prodigyapi_pageFilterPrimary {
              type
              title {
                text
                spans {
                  start
                  end
                }
              }
              sectionTitle {
                type
                text
                spans {
                  start
                  end
                }
              }
              bodyText {
                type
                text
                spans {
                  start
                  end
                }
              }
              bodyTextHtml
              sectionTitleHtml
              titleHtml
            }
            ... on prodigyapi_simpleBannerPrimary {
              type
              bannerCTAText
              bodycopyHtml
              image {
                url
                altTag
              }
              imageSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              heading {
                type
                text
                spans {
                  start
                  end
                }
              }
              buttonType
              bannerCTA {
                url
              }
              component
              subheading {
                text
                spans {
                  start
                  end
                }
              }
              colourOverrideBackground
              formId
              headingHtml
              subheadingHtml
              queryString
              ariaLabel
            }
            ... on prodigyapi_faqPrimary {
              type
              title {
                text
                type
                spans {
                  start
                  end
                  data_type
                  data {
                    url
                    uid
                    type
                    target
                    tags
                    slug
                    linkType
                    lang
                    isBroken
                    id
                    fontName
                  }
                }
              }
              imageLogo {
                url
                altTag
              }
              imageLogoSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              imageFAQ {
                url
                altTag
              }
              imageFAQSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              titleHtml
            }
            ... on prodigyapi_researchPrimary {
              type
              colour1
              bodycopy {
                text
                type
                spans {
                  start
                  end
                  data_type
                  data {
                    url
                    uid
                    type
                    target
                    tags
                    slug
                    linkType
                    lang
                    isBroken
                    id
                    fontName
                  }
                }
              }
              cta {
                url
              }
              headingText {
                text
                type
                spans {
                  start
                  end
                  data_type
                  data {
                    url
                    uid
                    type
                    target
                    tags
                    slug
                    linkType
                    lang
                    isBroken
                    id
                    fontName
                  }
                }
              }
              colour2
              buttonType
              ctaText
              imageAward {
                url
                altTag
              }
              labelColour1
              labelColour2
              subHeading {
                text
                spans {
                  start
                  end
                }
              }
              title {
                text
                type
                spans {
                  start
                  end
                  data_type
                  data {
                    url
                    uid
                    type
                    target
                    tags
                    slug
                    linkType
                    lang
                    isBroken
                    id
                    fontName
                  }
                }
              }
              imageResearch {
                url
                altTag
              }
              bodycopyHtml
              headingTextHtml
              imageResearchSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              imageAwardSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              subHeadingHtml
              titleHtml
              ariaLabel
              queryString
            }
            ... on prodigyapi_priceCardPrimary {
              type
              title {
                type
                text
                spans {
                  end
                  start
                }
              }
              titleHtml
              ctaText
              cta {
                url
              }
              ariaLabelCTA
              queryStringCTA
              sectionStyle
              backgroundImage {
                url
                altTag
              }
              mobileBackgroundImage {
                url
                altTag
              }
            }
            ... on prodigyapi_imageGalleryPrimary {
              type
            }
            ... on prodigyapi_CTAButtonPrimary {
              type
              ctaText
              buttonType
              link {
                url
              }
              queryString
              ariaLabel
            }
            ... on prodigyapi_modalPrimary {
              type
              ctaText
              buttonType
              image {
                url
                altTag
              }
              imageSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              textHtml
              titleHtml
            }
            ... on prodigyapi_socialEmbedPrimary {
              type
              embedCode
              shareLink {
                url
              }
            }
            ... on prodigyapi_hubspotFormPrimary {
              type
              formId
            }
          }
          items {
            ... on prodigyapi_articleGroupItems {
              type
              article {
                id
                url
                category {
                  text
                  id
                  title
                }
                metaData {
                  metatitle
                  metaDescription
                }
                title
                titleShort
                author {
                  name {
                    text
                  }
                  descriptionHtml
                  description {
                    text
                    type
                  }
                  id
                  nameHtml
                }
                publishDate
                headingData {
                  teaserTextHtml
                  teaserTextShortHtml
                  image {
                    url
                    altTag
                  }
                  imageExpanded {
                    imageBlogArticle {
                      url
                      altTag
                    }
                    imageBlogArticleSharp {
                      publicURL
                      childImageSharp {
                        gatsbyImageData(
                          quality: 90
                          placeholder: BLURRED
                          layout: FULL_WIDTH
                          formats: [AUTO, WEBP, AVIF]
                        )
                      }
                    }
                    imageThumbnail {
                      url
                      altTag
                    }
                    imageThumbnailSharp {
                      publicURL
                      childImageSharp {
                        gatsbyImageData(
                          quality: 90
                          placeholder: BLURRED
                          layout: FULL_WIDTH
                          formats: [AUTO, WEBP, AVIF]
                        )
                      }
                    }
                    imageFullsize {
                      url
                      altTag
                    }
                    imageFullsizeSharp {
                      publicURL
                      childImageSharp {
                        gatsbyImageData(
                          quality: 90
                          placeholder: BLURRED
                          layout: FULL_WIDTH
                          formats: [AUTO, WEBP, AVIF]
                        )
                      }
                    }
                    imageCard {
                      url
                      altTag
                    }
                    imageCardSharp {
                      publicURL
                      childImageSharp {
                        gatsbyImageData(
                          quality: 90
                          placeholder: BLURRED
                          layout: FULL_WIDTH
                          formats: [AUTO, WEBP, AVIF]
                        )
                      }
                    }
                  }
                  authorCredits
                  headline
                  headlineShort
                }
                tags
                slugs
                readingTimeHeading
                readingTime
              }
            }
            ... on prodigyapi_imageGalleryItems {
              type
              caption {
                text
                type
                spans {
                  start
                  end
                }
              }
              altText {
                type
                text
                spans {
                  start
                  end
                }
              }
              image {
                url
                altTag
              }
              captionHtml
              link {
                url
              }
              imageSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: CONSTRAINED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              ariaLabel
              queryString
            }
            ... on prodigyapi_columnImagesOverTextItems {
              type
              itemImage {
                altTag
                copyright
                url
              }
              imageItemSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              itemHeading {
                type
                text
                spans {
                  end
                  start
                }
              }
              itemBodyCopy {
                type
                text
                spans {
                  start
                  end
                  data {
                    fontName
                    id
                    isBroken
                    lang
                    linkType
                    slug
                    target
                    url
                    uid
                    type
                    tags
                  }
                  data_type
                }
              }
              ctaText
              cta {
                url
              }
              focusTextColour
              focusText
              itemSubHeading {
                text
                type
                spans {
                  start
                  end
                }
              }
              buttonType
              itemBodyCopyHtml
              image {
                url
                altTag
              }
              imageSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              imageItem {
                url
                altTag
              }
              itemHeadingHtml
              itemSubHeadingHtml
              ariaLabel
              queryString
            }
            ... on prodigyapi_awardItems {
              type
              image {
                url
                altTag
              }
              url
              hrefLink {
                url
              }
              uid
              titleHtml
              title {
                text
                type
              }
              imageSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              ariaLabel
              queryString
            }
            ... on prodigyapi_videoWithListItems {
              type
              group {
                type
                text
                spans {
                  start
                  end
                }
              }
              image {
                url
                altTag
              }
              imageSharp {
                publicURL
              }
              groupHtml
            }
            ... on prodigyapi_testimonialItems {
              type
              title {
                text
              }
              text {
                text
              }
              status {
                text
              }
              image {
                url
                altTag
              }
              giver {
                text
              }
              giverHtml
              statusHtml
              textHtml
              titleHtml
              uid
              imageSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    quality: 90
                    placeholder: BLURRED
                    layout: FULL_WIDTH
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
            }
            ... on prodigyapi_fullWidthImageAndTextBoxesItems {
              type
              ctaText
              textBox {
                type
                text
                spans {
                  data {
                    fontName
                    id
                    isBroken
                    lang
                    linkType
                    slug
                    tags
                    target
                    type
                    uid
                    url
                  }
                  data_type
                  end
                  start
                }
              }
              cta {
                url
              }
              title {
                type
                text
                spans {
                  data {
                    fontName
                    id
                    isBroken
                    lang
                    linkType
                    slug
                    tags
                    target
                    type
                    uid
                    url
                  }
                  data_type
                  end
                  start
                }
              }
              textBoxHtml
              titleHtml
              ariaLabel
              queryString
            }
            ... on prodigyapi_imageBesideTextItems {
              type
              imageAlignment
              title {
                text
                type
                spans {
                  data {
                    url
                    uid
                    type
                    target
                    tags
                    slug
                    lang
                    linkType
                    isBroken
                    id
                    fontName
                  }
                  start
                  end
                  data_type
                }
              }
              image {
                url
                altTag
              }
              imageSharp {
                publicURL
                childImageSharp {
                  gatsbyImageData(
                    layout: FULL_WIDTH
                    quality: 90
                    placeholder: BLURRED
                    formats: [AUTO, WEBP, AVIF]
                  )
                }
              }
              bodyText {
                type
                text
                spans {
                  start
                  end
                  data_type
                  data {
                    fontName
                    url
                    uid
                    type
                    target
                    tags
                    slug
                    linkType
                    lang
                    id
                    isBroken
                  }
                }
              }
              ctaText
              ctaType
              ctaLink {
                url
              }
              bodyTextHtml
              titleHtml
              queryString
              ariaLabel
            }
            ... on prodigyapi_pageFilterItems {
              type
              hrefLink {
                url
              }
            }
            ... on prodigyapi_faqItems {
              type
              question {
                text
                type
                spans {
                  start
                  end
                  data_type
                  data {
                    url
                    uid
                    type
                    target
                    tags
                    slug
                    linkType
                    lang
                    isBroken
                    id
                    fontName
                  }
                }
              }
              answer {
                text
                type
                spans {
                  start
                  end
                  data_type
                  data {
                    url
                    uid
                    type
                    target
                    tags
                    slug
                    linkType
                    lang
                    isBroken
                    id
                    fontName
                  }
                }
              }
              answerHtml
              questionHtml
            }
            ... on prodigyapi_priceCardItems {
              type
              component
              buttonType
              cta {
                url
              }
              ctaText
              currency
              disclaimer {
                type
                text
                spans {
                  start
                  end
                }
              }
              title {
                type
                text
                spans {
                  start
                  end
                }
              }
              savings
              productDescription {
                type
                text
                spans {
                  end
                  start
                }
              }
              price
              originalPrice
              legal {
                type
                text
                spans {
                  start
                  end
                }
              }
              label {
                type
                text
                spans {
                  end
                  start
                }
              }
              flagValue
              iconGroup {
                type
                text {
                  type
                  text
                  spans {
                    start
                    end
                  }
                }
                image {
                  url
                  altTag
                }
                textHtml
              }
              disclaimerHtml
              labelHtml
              legalHtml
              productDescriptionHtml
              titleHtml
              queryStringCTA
              ariaLabelCTA
            }
            ... on prodigyapi_imageGalleryItems {
              type
            }
          }
          label
        }
        headingData {
          teaserTextHtml
          teaserTextShortHtml
          authorCredits
          headline
          headlineShort
          image {
            url
            altTag
          }
          mediaHeading {
            url
          }
        }
      }
    }
  }
`;

export default IndexPage;
